import dayjs from 'dayjs'

/**
 * 正版使用页列表 / 排行「最近一个月」共用的 YYYY-MM-DD 区间（与 software-view `defaultMonthRange` 一致）：
 * 上月同日 0 点～今日 23:59:59，经 `useParseTime` 与列表请求对齐。
 */
export function defaultAuthenticSoftUsageMonthRangeStrings (): [string, string] {
  return [dayjs().subtract(1, 'month').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')]
}
